import { paymentApiClient } from '@/shared/api-client/payment-api-client';
import type { CheckoutSessionStatus, Invoice, Plan, Subscription } from '../payment-types';

export async function cancelSubscription(subscription_id: string) {
  const res = await paymentApiClient.post('v1/subscription/cancel', {
    json: {
      id: subscription_id,
    },
  });

  const data = await res.json();

  return data;
}

export const fetchInvoiceList = async (workspaceId: string): Promise<Invoice[]> => {
  const response = await paymentApiClient.get(`v1/workspaces/${workspaceId}/invoices`);
  return response.json();
};

export async function fetchPlanList(): Promise<Plan[]> {
  const response = await paymentApiClient.get<Plan[]>(`v1/products`);
  return response.json();
}

export async function createCheckoutSession({
  workspaceId,
  productId,
  priceId,
}: {
  workspaceId: string;
  productId: string;
  priceId: string;
}): Promise<string> {
  const response = await paymentApiClient.post<{ client_secret: string }>(`v1/checkout-sessions`, {
    json: {
      workspace_id: workspaceId,
      product_id: productId,
      price_id: priceId,
    },
  });

  const data = await response.json();
  return data.client_secret;
}

export async function fetchSessionStatus(session_id: string): Promise<CheckoutSessionStatus> {
  const res = await paymentApiClient.get<CheckoutSessionStatus>(
    `v1/checkout-sessions/${session_id}`,
  );

  const data = await res.json();

  return data;
}

export async function fetchSubscription(workspace_id: string): Promise<Subscription> {
  const res = await paymentApiClient.get<Subscription>(`v1/subscription/${workspace_id}`);
  return await res.json();
}
